import React, { useState, useEffect } from 'react';

import './styles.css';

import { useParams } from 'react-router';

import coachServices from '../../../services/academy/coachServices';

import loadTextTest from '../../../functions/loadTextTest';

import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';

import CoachProfileCard from './CoachProfileCard';
import CoachClassCard from './CoachClassCard';

export default function Coach(props) {
    const params = useParams();
    const [coachInfos, setCoachInfos] = useState({});
    // const [fetching, setFetching] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);



    function verifyIsAdmin() {
        setIsAdmin(props.history.location.pathname.includes("admin"));

    }

    useEffect(() => {
        verifyIsAdmin();
        readCoachInfos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function readCoachInfos() {
        const response = await coachServices.getCoachInfos(props.coachMode ? localStorage.getItem('_id') : params.id);
        // setFetching(false);
        if (response.status === 200) {
            setCoachInfos(response.data);
        } else
            alert("Erro ao ler informações de professor, tente novamente!");
    };

    async function deleteCoach(id, nome) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja apagar o(a) professor(a) ${nome}?`)) {
            const response = await coachServices.deleteCoach(id);
            if (response.status === 204) {
                props.history.goBack();
                console.log(`Professor ${nome} apagado!`);
            } else
                alert("Erro ao apagar professor, tente novamente!");
        }
    }



    async function disableCoach(id, nome) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja desativar o professor ${nome}?`)) {
            const response = await coachServices.disableCoach(id);
            if (response.status === 200) {
                setCoachInfos(response.data);
                console.log(`Professor ${nome} desativado!`);
            } else
                alert("Erro ao arquivar o professor, tente novamente!");
        }
    }

    async function activateCoach(id, nome) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja ativar o professor ${nome}?`)) {
            const response = await coachServices.activateCoach(id);
            if (response.status === 200) {
                setCoachInfos(response.data);
                console.log(`Professor ${nome} ativado!`);
            } else
                alert("Erro ao ativar o professor, tente novamente!");
        }
    }

    return (
        <MainView currentPage={isAdmin ? "academies" : props.coachMode ? "profile" : "coaches"} adminMenu={isAdmin}coachMenu={props.coachMode}>
            <NavHistory navPages={["Professores", loadTextTest(coachInfos.nome)]} />
            <div className='coach-page-cards'>
                <div className='coach-page-cards-group'>
                    <CoachProfileCard 
                    isAdmin={isAdmin} 
                    academyId={params.id} 
                    coachInfos={coachInfos} 
                    coachMode={props.coachMode} 
                    onDelete={deleteCoach}
                    onActivate={activateCoach}
                    onDisable={disableCoach}
                    />
                    <CoachClassCard coachInfos={coachInfos} onUpdate={readCoachInfos} />
                </div>
            </div>
        </MainView>
    )
}